import { useState } from 'react'

export const useDownload = () => {
  const [isDownloading, setDownloading] = useState(false)
  const [error, setError] = useState(null)

  const download = async (ref, filename) => {
    if (isDownloading) return

    setDownloading(true)
    setError(null)

    try {
      const [html2canvas, jsPDF] = await Promise.all([
        import('./html2canvas').then(module => module.default),
        import('jspdf').then(module => module.jsPDF),
      ])

      const canvas = await html2canvas(ref.current, {
        logging: process.env.NODE_ENV !== 'production',
        letterRendering: true,
        allowTaint: false,
        useCORS: true,
        scale: 2,
        backgroundColor: 'white',
      })

      // return document.body.appendChild(canvas) // debug
      const fileName = `${filename || 'download'}.pdf`
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [canvas.width, canvas.height],
        hotfixes: ['px_scaling'],
        compress: true,
      })
      const width = pdf.internal.pageSize.getWidth()
      const height = pdf.internal.pageSize.getHeight()
      pdf.addImage(canvas, 'PNG', 0, 0, width, height, '', 'FAST')
      const blob = pdf.output('blob')

      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

      // iOS Safari: link.download is ignored for blob URLs.
      // Web Share API (Level 2) triggers the native share/save sheet on iOS.
      if (isIOS && navigator.canShare) {
        const file = new File([blob], fileName, { type: 'application/pdf' })
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: fileName })
          setDownloading(false)
          return
        }
      }

      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setTimeout(() => URL.revokeObjectURL(url), 10000)

      setDownloading(false)
    } catch (e) {
      // console.error(e)
      setError(e?.message)
      setDownloading(false)
    }
  }

  return {
    isDownloading,
    download,
    error,
  }
}
